import {
  Button,
  Modal,
  Form,
  Flex,
  Typography,
  message,
  Select,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const UploadModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [incomeOptions, setIncomeOptions] = useState([]);
  const [expenseOptions, setExpenseOptions] = useState([]);
  const [incomeLoading, setIncomeLoading] = useState(false);
  const [expenseLoading, setExpenseLoading] = useState(false);

  const glChartOptions = [
    { label: "Z64", value: 1 },
    { label: "GEN", value: 2 },
  ];
  const serviceNameOptions = [
    { label: "Z64", value: 1 },
    { label: "GEN", value: 2 },
  ];

  const resolveGlChartNameId = (record) => {
    if (record?.glChartNameId) return record.glChartNameId;
    if (record?.glChartName === "Z64") return 1;
    if (record?.glChartName === "GEN") return 2;
    return undefined;
  };
  const resolveServiceNameId = (record) => {
    if (record?.serviceNameId) return record.serviceNameId;
    if (record?.serviceName === "Z64") return 1;
    if (record?.serviceName === "GEN") return 2;
    return undefined;
  };

  const buildOptionLabel = (record, type) => {
    if (type === "income") {
      return ( record?.serviceTitleName); }
    return (  record?.expensesTitleName);};

  useImperativeHandle(ref, () => ({
    open: async (record = {}) => {
      try {
        setCurrentRecord(record || null);
        const glChartNameId = resolveGlChartNameId(record);
        const serviceNameId = resolveServiceNameId(record);
        const incomeOption = record?.serviceId
          ? {
              value: record.serviceId,
              label: buildOptionLabel(record, "income"),
            }
          : null;
        const expenseOption = record?.expensesId
          ? {
              value: record.expensesId,
              label: buildOptionLabel(record, "expense"),
            }
          : null;

        form.setFieldsValue({
          glChartNameId,
          serviceNameId,
          serviceId: record?.serviceId,
          expensesId: record?.expensesId,
        });
        setIncomeOptions(incomeOption ? [incomeOption] : []);
        setExpenseOptions(expenseOption ? [expenseOption] : []);
        setVisible(true);
      } catch (error) {
        message.error("Failed to initialize modal data");
        console.error("Initialization error:", error);
      }
    },
  }));

  const closeModal = () => {
    setVisible(false);
    setCurrentRecord(null);
    form.resetFields();
  };

  const onFinishAdd = async (values) => {
    try {
      setLoading(true);

      const queryParams = {
        id: currentRecord?.id,
        glChartNameId: values.glChartNameId,
        serviceNameId: values.serviceNameId,
        serviceId: values.serviceId,
        expensesId: values.expensesId,
      };

      const response = await http.post(`${api.getGlAcctUpdate}`, queryParams);
      if (response.code === "1") {
        message.success("Update successfully.");
        closeModal();
        onSuccess?.();
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      message.error("Request Error");
    } finally {
      setLoading(false);
    }
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const normalizeOption = (item) => {
    if (!item) return null;
    const value = item.glChartId;
    const label = item.glAcctTitle || String(value ?? "");
    return { value, label };
  };

  const normalizeServiceOption = (item) => {
    if (!item) return null;
    const value = item.serviceId ?? item.id ?? null;
    const label =
      item.serviceTitleName ||
      item.serviceName ||
      item.remark ||
      String(value ?? "");
    if (value === null || value === undefined || value === "") return null;
    return { value, label };
  };

  const fetchGlOptions = async (acctType) => {
    const glChartNameId = form.getFieldValue("glChartNameId");
    const serviceNameId =
      form.getFieldValue("serviceNameId") || currentRecord?.serviceNameId;

    if (acctType === "I") {
      if (!serviceNameId) {
        message.warning("Please select Service Name first.");
        return;
      }
    } else if (!glChartNameId) {
      message.warning("Please select Gl Chart Name first.");
      return;
    }

    const setLoadingFn = acctType === "I" ? setIncomeLoading : setExpenseLoading;
    const setOptionsFn = acctType === "I" ? setIncomeOptions : setExpenseOptions;

    setLoadingFn(true);
    try {
      if (acctType === "I") {
        const response = await http.get(api.getServiceCodeDict, {
          params: { serviceNameId },
        });
        const list = response?.data || [];
        setOptionsFn(list.map(normalizeServiceOption).filter(Boolean));
      } else {
        const response = await http.get(api.getGlAcctTypeOption, {
          params: { acctType, glChartNameId },
        });
        const list = response?.data || [];
        setOptionsFn(list.map(normalizeOption).filter(Boolean));
      }
    } catch (error) {
      message.error("Failed to load GL accounts");
    } finally {
      setLoadingFn(false);
    }
  };

  return (
    <>
      <Modal
        title={
          <Flex justify="flex-start" align="flex-start" className="model_title">
            <EditOutlined className="model_title_mr10" />
            <Typography.Title level={4} className="mg">
              UPLOAD GLACCTTYPEOPTION
            </Typography.Title>
          </Flex>
        }
        width="50%"
        open={visible}
        onCancel={closeModal}
        footer={
       <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button key="back" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
        }
        centered
      >
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div className="model_content">
              <Form
                {...layout}
                name="AddForm"
                onFinish={onFinishAdd}
                form={form}
                labelCol={{
                  style: {
                    width: "150px",
                  },
                }}
                wrapperCol={{
                  style: {
                    flex: 1,
                  },
                }}
              >
                <Form.Item
                  name="glChartNameId"
                  label="Gl Chart Name"
                  rules={[{ required: true, message: "Please select Gl Chart Name" }]}
                >
                  <Select
                    options={glChartOptions}
                    placeholder="Please select Gl Chart Name"
                    onChange={() => {
                      form.setFieldsValue({
                        expensesId: undefined,
                      });
                      setExpenseOptions([]);
                    }}
                  />
                </Form.Item>

                 <Form.Item
                  name="expensesId"
                   label="GI Account"
                  rules={[{ required: true, message: "Please select GI Account" }]}
                >
                  <Select
                    options={expenseOptions}
                    loading={expenseLoading}
                    placeholder="Please select GI Account"
                    onDropdownVisibleChange={(open) =>
                      open && fetchGlOptions("E")
                    }
                    showSearch
                    optionFilterProp="label"
                  />
                </Form.Item>

                <Form.Item
                  name="serviceNameId"
                  label="Service Name"
                  rules={[{ required: true, message: "Please select Service Name" }]}
                >
                  <Select
                    options={serviceNameOptions}
                    placeholder="Please select Service Name"
                    onChange={() => {
                      form.setFieldsValue({
                        serviceId: undefined,
                      });
                      setIncomeOptions([]);
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name="serviceId"
                  label="Service Code"
                  rules={[{ required: true, message: "Please select Service Code" }]}
                >
                  <Select
                    options={incomeOptions}
                    loading={incomeLoading}
                    placeholder="Please select Service Code"
                    onDropdownVisibleChange={(open) =>
                      open && fetchGlOptions("I")
                    }
                    showSearch
                    optionFilterProp="label"
                  />
                </Form.Item>

             
              </Form>
            </div>
          </div>
        </Flex>
      </Modal>
    </>
  );
});

export default UploadModal;
